var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.763 13.928C11.697 15.565 10.3127 16.9551 8.45837 16.9104C8.02696 16.8999 7.49374 16.7518 6.42733 16.4553C3.8608 15.7418 1.63282 14.5426 1.09827 11.8564C1 11.3628 1 10.8071 1 9.69585V8.21556C1 7.10433 1 6.54871 1.09827 6.05493C1.63282 3.36872 3.8608 2.16963 6.42733 1.45615C7.49374 1.15968 8.02696 1.01145 8.45837 1.00105C10.3127 0.956338 11.697 2.34634 11.763 3.9834",
    stroke: "#818183",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1444 8.95601H7.27832M17.1444 8.95601C17.1444 8.33706 15.3557 7.18059 14.9021 6.74609M17.1444 8.95601C17.1444 9.57497 15.3557 10.7315 14.9021 11.1659",
    stroke: "#818183",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.05d5b62e2286e5de85dab73df8879c73.svg";
export { ForwardRef as ReactComponent };